import { isLocal } from "../utils/env";
import { log } from "../utils/logger";

import { isDev } from "../utils/env";
import { client_config } from "../utils/clientConfigs";

import async from "../components/Async";
import {
  Settings as AdminIcon,
  Database as DataIcon,
  Send as CampaignIcon,
  Layout as LayoutIcon,
  List as ListIcon,
  Sliders as SliderIcon,
  Users as UsersIcon,
  User as UserIcon,
} from "react-feather";

// Auth
// import Register from "../pages/auth/Register";
import SignIn from "../pages/auth/SignIn";
import PasswordReset from "../pages/auth/PasswordReset";
import RequestPasswordReset from "../pages/auth/RequestPasswordReset";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

// Account
import Account from "../pages/account";

// Administration
import AdminApprover from "../pages/administration/Approvers";
import AdminSeedLists from "../pages/administration/SeedList";
import AdminUserPermissions from "../pages/administration/UserPermissions";
import AdminWhitelist from "../pages/administration/Whitelist";
import AdminSuppressionlist from "../pages/administration/Suppressionlist";

// Misc
import Blank from "../pages/misc/Blank";
import Invoice from "../pages/misc/Invoice";
import Pricing from "../pages/misc/Pricing";

// Dashboards - lazy load
const Campaigns = async(() => import("../pages/dashboards/Campaigns"));
const StandardReports = async(() => import("../pages/dashboards/StandardReports"));

// Datasets
const DataSummary = async(() => import("../pages/data/Summary"));
const DatasetDetail = async(() => import("../pages/data/DatasetDetail")); // View Single Dataset Details
const ViewDatasets = async(() => import("../pages/data/ViewDatasets"));
const CreateDataset = async(() => import("../pages/data/CreateDataset"));
const UploadDataset = async(() => import("../pages/data/UploadDataset"));

// Campaigns
const CreateCampaignAdHoc = async(() => import("../pages/campaigns/CreateCampaignAdHoc"));
const ViewCampaign = async(() => import("../pages/campaigns/ViewCampaign"));
const ApproveCampaign = async(() => import("../pages/campaigns/ApproveCampaign"));
const ViewFolder = async(() => import("../pages/campaigns/ViewFolder"));

// Routes
const landingRoutes = {
  path: "/",
  name: "Sign In",
  component: SignIn,
  children: null,
};

const dashboardRoutes = {
  path: "/dashboard",
  name: "Dashboard",
  header: "Dashboards",
  // badgeColor: "primary",
  // badgeText: "5",
  icon: ListIcon,
  containsHome: true,
  isPrivate: true,
  children: [
    {
      path: "/dashboard/campaigns",
      name: "Campaigns",
      component: Campaigns,
    },
    {
      path: "/dashboard/standard-reports",
      link: "/dashboard/standard-reports?r=true",
      name: "Standard Reports",
      component: StandardReports,
      icon: SliderIcon,
    },
  ],
};

//Add suppression list only if activated for Client
if (client_config.enabled_features.suppression_list && 
  client_config.enabled_features.suppression_list.length>0
) {
  // Routes to remove
  dashboardRoutes.children.push({
    path: "/dashboard/suppressionlist",
    name: "Manage Suppression List",
    component: AdminSuppressionlist,
  });
}

const dataRoutes = {
  path: "/data",
  name: "Data",
  icon: DataIcon,
  isPrivate: true,
  children: [
    {
      path: "/data/summary",
      name: "Data Summary",
      component: DataSummary,
    },
    {
      path: "/data/view",
      name: "View Datasets",
      component: ViewDatasets,
    },
    {
      path: "/data/create",
      name: "Create Dataset",
      component: CreateDataset,
      restrictedToLevel: 2,
    },
    {
      path: "/data/upload",
      name: "Upload Dataset",
      component: UploadDataset,
      restrictedToLevel: 2,
    },
  ],
};

// DLC-68 Only show Data Summary and Create Dataset view for clients with the feature enabled
if (!client_config.enabled_features.dataset_import) {
  // Routes to remove
  const disable_routes = ["Data Summary", "Create Dataset"];

  // Execute filter
  dataRoutes.children = dataRoutes.children.filter(({ name }) => !disable_routes.includes(name));
}

const campaignRoutes = {
  path: "/campaigns",
  name: "Campaigns",
  icon: CampaignIcon,
  isPrivate: true,
  children: [
    // {
    //   path: "/campaigns/create/template",
    //   name: "Create Campaign",
    //   component: CreateCampaignTemplate,
    // },
    {
      path: "/campaigns/create/ad-hoc",
      name: "Create Ad Hoc Campaign",
      component: CreateCampaignAdHoc,
      restrictedToLevel: 2,
    },
    // Separate page for managing Inbound Messages
    // {
    //   path: "/campaigns/in-bound-message",
    //   name: "Manage Inbound Messages",
    //   component: async(() => import("../pages/campaigns/InBoundMessage")),
    //   restrictedToLevel: 2,
    // },
  ],
};

const accountRoutes = {
  path: "/account/:view",
  link: "/account/profile",
  name: "Account",
  icon: UserIcon,
  header: "Settings",
  component: Account,
  isPrivate: true,
};

const administrationRoutes = {
  path: "/admin",
  name: "Administration",
  icon: AdminIcon,
  isPrivate: true,
  restrictedToLevel: 1,
  children: [
    {
      path: "/admin/manage-users",
      name: "Manage User Permissions",
      component: AdminUserPermissions,
      restrictedToLevel: 3,
    },
    {
      path: "/admin/seed-lists",
      name: "Manage Seed Lists",
      component: AdminSeedLists,
      restrictedToLevel: 3,
    },
    {
      path: "/admin/approvers",
      name: "Manage Approvers",
      component: AdminApprover,
      restrictedToLevel: 3,
    },
  ],
};

// Only show whitelist component outside PRODUCTION environment
if (isDev()) {
  administrationRoutes.children.push({
    path: "/admin/whitelist",
    name: "Manage Whitelist",
    component: AdminWhitelist,
    restrictedToLevel: 3,
    environments: ["local", "dev"],
  });
}

const pageRoutes = {
  path: "/pages",
  name: "Pages",
  icon: LayoutIcon,
  header: "Samples",
  children: [
    {
      path: "/pages/invoice",
      name: "Invoice",
      component: Invoice,
    },
    {
      path: "/pages/pricing",
      name: "Pricing",
      component: Pricing,
    },
    {
      path: "/pages/blank",
      name: "Blank Page",
      component: Blank,
    },
  ],
};

const authRoutes = {
  path: "/auth",
  name: "Auth",
  icon: UsersIcon,
  badgeColor: "secondary",
  badgeText: "internal",
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    // Currently disabled self-registration
    // {
    //   path: "/auth/register",
    //   name: "Register",
    //   component: Register,
    // },
    {
      path: "/auth/request-reset",
      name: "Reset Password",
      component: RequestPasswordReset,
    },
    {
      path: "/auth/password-reset",
      name: "Reset Password",
      component: PasswordReset,
    },
    {
      path: "/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/500",
      name: "500 Page",
      component: Page500,
    },
  ],
};

// These routes are not visible in the sidebar
const privateRoutes = {
  path: "/private",
  name: "Private",
  children: [
    {
      path: "/folder/view/:folder_id",
      name: "View Folder",
      component: ViewFolder,
      isPrivate: true,
    },
    {
      path: "/campaign/view/:campaign_id",
      name: "View Campaign",
      component: ViewCampaign,
      isPrivate: true,
    },
    {
      path: "/campaign/approve/:campaign_id",
      name: "Approve Campaign",
      component: ApproveCampaign,
      isPrivate: true,
    },
    {
      path: "/data/view/:dataset_id",
      name: "Dataset Detail",
      component: DatasetDetail,
      isPrivate: true,
    },
  ],
};

// Landing specific routes
export const landing = [landingRoutes];

// Dashboard specific routes
export const dashboard = [dashboardRoutes, privateRoutes];

export const data = [dataRoutes];

export const campaign = [campaignRoutes];

// Auth specific routes
export const auth = [authRoutes];

// Account specific routes
export const account = [accountRoutes];

// Administration specific routes
export const administration = [administrationRoutes];

// All routes - order determines side nav position
const AllRoutes = [
  dashboardRoutes,
  dataRoutes,
  campaignRoutes,
  accountRoutes,
  administrationRoutes,
];

if (isLocal()) {
  log("---- Adding local test routes ----");
  AllRoutes.push(pageRoutes, authRoutes);
}

export default AllRoutes;
